import { render } from "./NavbarLayout.vue?vue&type=template&id=3e127a58"
import script from "./NavbarLayout.vue?vue&type=script&lang=js"
export * from "./NavbarLayout.vue?vue&type=script&lang=js"

import "./NavbarLayout.vue?vue&type=style&index=0&id=3e127a58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__